export default function getPrevLinkedItemState() {
    return {
        data: {}
    };
}



// WEBPACK FOOTER //
// ./src/MerchantItems/Reducer/getPrevLinkedItemState.js